export { default as DevelopmentProduct } from './page';


// WEBPACK FOOTER //
// ./src/pages/developmentProduct/index.js